import { get, isObject } from "lodash";

export const getNodeValue = (parentNode, nodeName) => {
  const node = get(parentNode, `${nodeName}[0]`);
  if (!node || !isObject(node)) return node;
  return get(node, "_");
};

export const addReportIdToAdditionalData = (props, additionalData) => {
  if (
    props &&
    props.additionalData &&
    props.additionalData.reportIds &&
    props.additionalData.reportIds.length > 0 &&
    additionalData
  ) {
    additionalData.reportId = props.additionalData.reportIds[0];
    additionalData.ignoreReportId = true;
  }
};

export default addReportIdToAdditionalData;



// WEBPACK FOOTER //
// ./src/components/common/Utils.js